import { Link } from 'react-router-dom';
import { siteContent as c } from '@/content/siteContent';

/* Map des routes par label de menu */
const ROUTE_MAP: Record<string, string> = {
  'Accueil': '/',
  'La Fondasyon': '/la-fondasyon',
  'Nos Activités': '/',
  'Events': '/',
  'Boutique': '/',
  'Contact': '/',
};

/**
 * Page d'accueil FONDASYON FELICITEE — v2 (avec footer premium)
 * Tous les textes sont gérés dans src/content/siteContent.ts
 */
export default function HomeV2() {
  return (
    <div className="min-h-screen overflow-x-hidden bg-white" style={{ fontFamily: "'Inter', sans-serif" }}>
      {/* ═══ STYLES LOCAUX ═══ */}
      <style>{`
        .font-script { font-family: 'Dancing Script', cursive; }
        .font-montserrat { font-family: 'Montserrat', sans-serif; }
        .font-headline { font-family: 'Plus Jakarta Sans', sans-serif; }
        .material-symbols-outlined { font-variation-settings: 'FILL' 0, 'wght' 400; }
        .event-card-hover:hover img { filter: grayscale(0%); }
        .event-card-hover img { filter: grayscale(100%); transition: filter 0.5s ease-in-out; }
        @keyframes kenburns { 0% { transform: scale(1); } 100% { transform: scale(1.02); } }
        .animate-ken-burns { animation: kenburns 8s ease-in-out infinite alternate; }
        .diamond-pattern { background-image: radial-gradient(rgba(255,255,255,0.08) 1px, transparent 1px); background-size: 20px 20px; }
        @keyframes staggeredFadeIn { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
        .word-fade-in { display: inline-block; opacity: 0; animation: staggeredFadeIn 0.4s forwards; }
        .btn-hover-fill { position: relative; z-index: 1; transition: color 0.3s ease; overflow: hidden; }
        .btn-hover-fill::before { content: ''; position: absolute; top: 0; left: 100%; bottom: 0; right: 0; background: #0D1F6E; transition: left 0.3s ease; z-index: -1; border-radius: inherit; }
        .btn-hover-fill:hover::before { left: 0; }
        .btn-hover-fill:hover { color: white !important; }
        @keyframes subtle-pulse { 0%, 100% { transform: scale(1); } 50% { transform: scale(1.05); } }
        .animate-subtle-pulse { animation: subtle-pulse 3s infinite ease-in-out; }
        .card-hover-zoom img { transition: transform 0.5s ease-in-out; }
        .card-hover-zoom:hover img { transform: scale(1.1); }
        .hover-lift { transition: all 0.3s ease-in-out; }
        .hover-lift:hover { transform: translateY(-8px) scale(1.02); box-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1); }
        .silk-gradient { background: linear-gradient(135deg, #24408d 0%, #3e58a6 100%); }
        .group:hover .mega-menu { opacity: 1; visibility: visible; transform: translateY(0); }
        /* Footer premium */
        .ff-footer { background: linear-gradient(180deg, #0D1F6E 0%, #1A2E8F 55%, #0B184F 100%); position: relative; overflow: hidden; }
        .ff-footer::before { content: ''; position: absolute; inset: 0; background-image: radial-gradient(rgba(245,200,66,0.08) 1px, transparent 1px); background-size: 28px 28px; pointer-events: none; opacity: .6; }
        .ff-footer::after { content: ''; position: absolute; top: 0; left: 0; right: 0; height: 1px; background: linear-gradient(90deg, transparent, #F5C842 20%, #F5C842 80%, transparent); }
        .ff-gold-line { background: linear-gradient(90deg, #F5C842 0%, transparent 100%); }
        .ff-link { position: relative; transition: color .3s ease, padding-left .3s ease; }
        .ff-link::before { content: ''; position: absolute; left: 0; top: 50%; width: 0; height: 1px; background: #F5C842; transition: width .3s ease; }
        .ff-link:hover { color: #F5C842; padding-left: 18px; }
        .ff-link:hover::before { width: 12px; }
        .ff-social { width: 44px; height: 44px; border-radius: 50%; display: inline-flex; align-items: center; justify-content: center; border: 1px solid rgba(245,200,66,.25); transition: all .4s cubic-bezier(.4,0,.2,1); background: rgba(255,255,255,.03); }
        .ff-social:hover { background: #F5C842; border-color: #F5C842; transform: translateY(-4px); box-shadow: 0 10px 25px rgba(245,200,66,.35); }
        .ff-social:hover .material-symbols-outlined { color: #0D1F6E !important; }
        .ff-newsletter-input { background: rgba(255,255,255,.05); border: 1px solid rgba(255,255,255,.12); transition: all .3s ease; }
        .ff-newsletter-input:focus { background: rgba(255,255,255,.08); border-color: #F5C842; outline: none; box-shadow: 0 0 0 3px rgba(245,200,66,.15); }
        .ff-pay-badge { transition: all .3s ease; }
        .ff-pay-badge:hover { background: rgba(245,200,66,.15); border-color: #F5C842; transform: translateY(-2px); }
        .ff-brand-wordmark { background: linear-gradient(135deg, #FFFFFF 0%, #F5C842 100%); -webkit-background-clip: text; background-clip: text; -webkit-text-fill-color: transparent; }
        @keyframes ff-glow { 0%, 100% { box-shadow: 0 0 0 0 rgba(245,200,66,.4); } 50% { box-shadow: 0 0 0 12px rgba(245,200,66,0); } }
        .ff-pulse-dot { animation: ff-glow 2.5s infinite; }
      `}</style>

      {/* ═══ HEADER ═══ */}
      <header className="w-full z-50 fixed top-0">
        <div className="bg-[#f6f7f8] border-b border-gray-200 py-2 hidden md:block">
          <div className="container mx-auto max-w-7xl flex justify-between items-center text-[11px] font-bold text-gray-500 uppercase tracking-wider px-4 md:px-8">
            <div className="flex gap-6">
              <a href="#" className="flex items-center gap-2 hover:text-[#24408d] transition-colors"><span className="material-symbols-outlined text-[16px]">credit_card</span>{c.topBar.paymentOptions}</a>
              <a href="#" className="flex items-center gap-2 hover:text-[#24408d] transition-colors"><span className="material-symbols-outlined text-[16px]">fact_check</span>{c.topBar.termsConditions}</a>
            </div>
            <div className="flex gap-6 items-center">
              <div className="flex items-center gap-2"><span className="material-symbols-outlined text-[#24408d] text-[16px]">location_on</span>{c.topBar.location}</div>
              <div className="flex items-center gap-2"><span className="material-symbols-outlined text-[#24408d] text-[16px]">mail</span>{c.topBar.email}</div>
            </div>
          </div>
        </div>
        <div className="bg-white/95 backdrop-blur-md shadow-sm py-2 relative">
          <div className="container mx-auto max-w-7xl flex justify-between items-center px-4 md:px-8">
            <div className="flex-shrink-0">
              <img alt="Fondasyon Felicitée Logo" className="h-12 md:h-16 object-contain" src="/images/logo FF.png" />
            </div>
            <nav className="hidden lg:flex items-center gap-6 xl:gap-8 h-16">
              {c.navbar.menuItems.map((item, i) => (
                <Link key={i} to={ROUTE_MAP[item.label] || '/'} className={`font-headline font-extrabold text-sm uppercase tracking-widest transition-colors ${item.active ? 'text-[#24408d] border-b-2 border-[#24408d]' : 'text-gray-700 hover:text-[#24408d]'}`}>
                  {item.label}
                </Link>
              ))}
            </nav>
            <div className="flex items-center gap-4">
              <button className="bg-[#00c5a3] hover:bg-[#00b092] text-white px-6 xl:px-8 py-3 rounded-full font-headline font-extrabold text-sm uppercase tracking-widest transition-all shadow-lg active:scale-95 whitespace-nowrap">
                {c.navbar.donateButton}
              </button>
            </div>
          </div>
        </div>
      </header>

      <main>
        {/* ═══ HERO ═══ */}
        <section className="relative min-h-screen flex items-center pt-32">
          <div className="absolute inset-0 z-0 overflow-hidden">
            <img className="w-full h-full object-cover" src="https://lh3.googleusercontent.com/aida-public/AB6AXuByRRuZNQhyeUmNosvyvtO9B8M0WceCnNmMTKVJUW1Gjv5JsFGoc2okJkDJZQS4naLJP8IXY5gks_IFuPK5tVFBYpaivSs6LY8JZ-xC2ZANOYFFo1u_539C0OUBow_lik3nlj1VqZFpwZeqtSInpZ2RfUkZIMNJip2FbV60mnCGvKsT8-OXDwFc7kbnHadnjN3ADGVU-ny6C2Trv6IKmGWmr2-JxFmwLFdnC8JfOgC8BSv-PkaG7vEau1lC4bnTImt-wdUWN2Uj0R0" alt="" />
            <div className="absolute inset-0 bg-gradient-to-r from-[#24408d]/80 to-transparent"></div>
          </div>
          <div className="container mx-auto max-w-7xl px-4 md:px-8 relative z-10">
            <div className="max-w-3xl">
              <span className="bg-[#fdd34d] text-[#725b00] px-4 py-1.5 rounded-full text-xs font-bold font-headline uppercase tracking-widest mb-6 inline-block">{c.hero.badge}</span>
              <h1 className="text-white font-headline font-bold text-5xl md:text-7xl lg:text-8xl leading-[1.1] mb-8 tracking-tighter">
                {c.hero.titreLigne1} <br /><span className="text-[#fdd34d]">{c.hero.titreLigne2}</span>
              </h1>
              <p className="text-white/90 text-lg md:text-xl lg:text-2xl max-w-xl mb-12 leading-relaxed">{c.hero.description}</p>
              <div className="flex flex-col sm:flex-row flex-wrap gap-4">
                <button className="silk-gradient text-white px-10 py-4 rounded-full font-headline font-bold text-lg hover:shadow-xl transition-all flex items-center justify-center gap-2">{c.hero.boutonPrimaire}<span className="material-symbols-outlined">favorite</span></button>
                <button className="bg-white/10 backdrop-blur-md border border-white/20 text-white px-10 py-4 rounded-full font-headline font-bold text-lg hover:bg-white/20 transition-all flex items-center justify-center gap-2">{c.hero.boutonSecondaire}<span className="material-symbols-outlined">arrow_forward</span></button>
              </div>
            </div>
          </div>
        </section>

        {/* ═══ PROJETS PHARES ═══ */}
        <section className="py-24 bg-white">
          <div className="container mx-auto max-w-7xl px-4 md:px-8">
            <div className="text-center mb-16">
              <h2 className="text-[#24408d] font-headline font-bold text-4xl mb-4 tracking-tighter">{c.projetsPhares.titre}</h2>
              <div className="h-1 w-24 bg-[#fdd34d] rounded-full mx-auto"></div>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 xl:gap-12">
              {c.projetsPhares.projets.map((p, i) => (
                <div key={i} className="flex flex-col bg-[#f2f4f6] overflow-hidden shadow-sm hover-lift group card-hover-zoom">
                  <div className="h-[280px] overflow-hidden">
                    <img alt={p.titre} className="w-full h-full object-cover" src={`https://picsum.photos/seed/ff${i + 1}/600/400`} />
                  </div>
                  <div className="p-8 pb-10 flex flex-col flex-grow">
                    <span className="text-[#ba1a1a] italic font-headline text-lg mb-4">{p.tagline}</span>
                    <h3 className="text-[#24408d] font-headline font-extrabold text-2xl mb-4 leading-tight">{p.titre}</h3>
                    <p className="text-[#444651] text-sm md:text-base mb-12 flex-grow">{p.description}</p>
                    <div className="relative pt-1">
                      <div className="flex items-center justify-end mb-2"><span className="text-[#ba1a1a] italic font-bold text-lg">{p.pourcentage}%</span></div>
                      <div className="overflow-hidden h-2.5 mb-8 text-xs flex rounded bg-[#ba1a1a]/20">
                        <div className="bg-[#ba1a1a]" style={{ width: `${p.pourcentage}%` }}></div>
                      </div>
                    </div>
                    <div className="flex justify-between items-center text-[#ba1a1a] font-bold text-sm">
                      <span>Raised: {p.montantCollecte}</span>
                      <span>Goal: {p.objectif}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ═══ ABOUT ═══ */}
        <section className="py-24 bg-[#f8f9fc]">
          <div className="container mx-auto max-w-7xl px-4 md:px-8">
            <div className="flex flex-col lg:flex-row gap-16 items-start">
              <div className="w-full lg:w-5/12 relative">
                <div className="relative z-10 overflow-hidden shadow-2xl bg-white rounded-full">
                  <img alt="Mission" className="w-full h-auto object-cover" src="https://picsum.photos/seed/ff-about/600/600" />
                </div>
                <div className="absolute -right-6 md:-right-12 top-1/2 -translate-y-1/2 bg-[#fdd34d] p-10 md:p-12 z-20 shadow-xl min-w-[180px] md:min-w-[240px] flex flex-col items-center justify-center text-[#725b00] rounded-full">
                  <span className="material-symbols-outlined text-4xl md:text-6xl mb-4">handshake</span>
                  <div className="text-4xl md:text-6xl font-headline font-black mb-1">{c.about.statBadge.nombre}</div>
                  <div className="text-xs md:text-sm font-bold uppercase tracking-[0.2em] opacity-80">{c.about.statBadge.label}</div>
                </div>
              </div>
              <div className="w-full lg:w-7/12 lg:pl-12 pt-8">
                <span className="text-[#444651] font-headline font-bold text-sm uppercase tracking-[0.3em] mb-6 block">{c.about.surtitre}</span>
                <h2 className="text-[#24408d] font-headline font-black text-4xl md:text-6xl mb-10 leading-tight tracking-tighter uppercase">{c.about.titre}</h2>
                <p className="text-[#444651] text-base md:text-lg leading-relaxed font-medium text-justify mb-6">{c.about.paragraphe1}</p>
                <p className="text-[#191c1e] text-base md:text-lg leading-relaxed mb-12">{c.about.paragraphe2}</p>
                <div className="relative p-10 bg-white/50 backdrop-blur-sm rounded-3xl border-l-8 border-[#fdd34d] shadow-sm">
                  <h3 className="text-[#24408d] font-headline font-bold text-xl md:text-2xl leading-snug italic mb-6">« {c.about.citation} »</h3>
                  <div className="flex items-center gap-4">
                    <div className="h-0.5 w-12 bg-[#735c00]"></div>
                    <p className="text-[#191c1e] font-headline font-bold text-sm tracking-wide">— {c.about.citationAuteur}, <span className="text-[#444651] font-normal opacity-70">{c.about.citationFonction}</span></p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* ═══ BANNIÈRE 3 COLONNES ═══ */}
        <section className="w-full h-[580px] overflow-hidden">
          <div className="flex flex-col md:flex-row h-full">
            <div className="w-full md:w-[38%] h-full relative overflow-hidden">
              <div className="absolute inset-0 z-0">
                <img alt="Heritage" className="w-full h-full object-cover animate-ken-burns" src="https://lh3.googleusercontent.com/aida-public/AB6AXuByRRuZNQhyeUmNosvyvtO9B8M0WceCnNmMTKVJUW1Gjv5JsFGoc2okJkDJZQS4naLJP8IXY5gks_IFuPK5tVFBYpaivSs6LY8JZ-xC2ZANOYFFo1u_539C0OUBow_lik3nlj1VqZFpwZeqtSInpZ2RfUkZIMNJip2FbV60mnCGvKsT8-OXDwFc7kbnHadnjN3ADGVU-ny6C2Trv6IKmGWmr2-JxFmwLFdnC8JfOgC8BSv-PkaG7vEau1lC4bnTImt-wdUWN2Uj0R0" />
              </div>
              <div className="absolute inset-0 bg-[#1A2E8F]/30 z-10"></div>
              <div className="absolute bottom-8 left-8 z-20">
                <span className="bg-[#F5C842] text-[#1A2E8F] font-montserrat font-bold text-sm px-4 py-2 tracking-widest">{c.banniere.badgeGauche}</span>
              </div>
            </div>
            <div className="w-full md:w-[28%] h-full bg-[#1A2E8F] diamond-pattern flex flex-col justify-center px-10 relative z-10">
              <blockquote className="text-white font-montserrat font-extrabold text-[22px] leading-[1.4] mb-6">
                {c.banniere.citation.split(' ').map((word, i) => (
                  <span key={i} className="word-fade-in mr-1" style={{ animationDelay: `${0.1 + i * 0.1}s` }}>{word}</span>
                ))}
              </blockquote>
              <div className="w-10 h-[2px] bg-[#F5C842] mb-8"></div>
              <div className="mb-8">
                <div className="text-white font-montserrat font-bold text-[13px] tracking-widest uppercase mb-1">{c.banniere.brandLigne1}</div>
                <div className="text-white/60 text-[11px] tracking-wider">{c.banniere.brandLigne2}</div>
              </div>
              <button className="bg-[#F5C842] text-[#1A2E8F] font-montserrat font-extrabold text-sm px-8 py-4 rounded-[30px] tracking-widest shadow-[0_4px_15px_rgba(245,200,66,0.3)] animate-subtle-pulse btn-hover-fill whitespace-nowrap w-fit">
                {c.banniere.bouton}
              </button>
            </div>
            <div className="w-full md:w-[34%] h-full relative overflow-hidden">
              <div className="absolute inset-0 z-0">
                <img alt="Community" className="w-full h-full object-cover animate-ken-burns" src="https://lh3.googleusercontent.com/aida-public/AB6AXuCh8iJNGQ15V6gcp5fJavkaTKp0ifr58x8ek9Oi8m_oCpa-mQ18TB66_MBSdk2G954xhrimFX1BKL_OD04JuTkzUOc-EHFmtIuq5eAWH8inqbgS996nItujbFMpIIC8WLz622G1BOwZkx82MBZt41L0hFe2TRK7xlgO27rukL8aZeSrogV77WeLkD9TEZeuttTGV4rbh1cGF03VJV9ZfQTilBWMBtTGzxZbhhLa5eUw70sZ1yFiBS3Jd5tdguKEIgBY6aLWGbttE48" />
              </div>
              <div className="absolute inset-0 bg-gradient-to-r from-[#1A2E8F]/40 to-transparent z-10"></div>
              <div className="absolute bottom-8 right-8 z-20">
                <span className="bg-black/50 backdrop-blur-md text-white font-montserrat font-bold text-[10px] px-4 py-2 tracking-widest uppercase border border-white/20">{c.banniere.badgeDroite}</span>
              </div>
            </div>
          </div>
        </section>

        {/* ═══ UBUNTU EN ACTION ═══ */}
        <section className="py-24 bg-[#f8f9fc]">
          <div className="container mx-auto max-w-7xl px-4 md:px-8">
            <div className="text-center mb-20">
              <h2 className="text-[#24408d] font-headline font-bold text-4xl mb-4 uppercase tracking-tighter">{c.ubuntu.titre}</h2>
              <p className="text-[#444651] text-xl">{c.ubuntu.sousTitre}</p>
              <div className="h-1.5 w-20 bg-[#fdd34d] mx-auto mt-6 rounded-full"></div>
            </div>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-6 lg:gap-8">
              {c.ubuntu.stats.map((s, i) => (
                <div key={i} className="text-center p-8 bg-[#f2f4f6] rounded-full">
                  <span className="material-symbols-outlined text-[#735c00] text-5xl mb-4">{s.icone}</span>
                  <div className="text-4xl lg:text-5xl font-headline font-extrabold text-[#24408d] mb-2">{s.nombre}</div>
                  <div className="text-[#444651] font-bold text-sm uppercase">{s.label}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ═══ ÉVÉNEMENTS ═══ */}
        <section className="bg-white">
          <div className="bg-[#1A2E8F] py-20">
            <div className="container mx-auto max-w-7xl px-4 md:px-8">
              <div className="w-full md:w-2/3">
                <p className="font-script text-[#F5C842] text-3xl md:text-4xl mb-2">{c.evenements.accroche}</p>
                <h2 className="font-montserrat font-extrabold text-white text-5xl md:text-7xl uppercase mb-8 tracking-tighter">{c.evenements.titre}</h2>
                <p className="text-white/80 text-lg md:text-xl max-w-2xl leading-relaxed">{c.evenements.description}</p>
              </div>
            </div>
          </div>
          <div className="container mx-auto max-w-7xl px-4 md:px-8 -mt-10 pb-24">
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
              {c.evenements.liste.map((ev, i) => (
                <div key={i} className="group relative overflow-hidden aspect-[3/4] rounded-lg shadow-xl event-card-hover">
                  <img alt={ev.titre} className="absolute inset-0 w-full h-full object-cover" src={`https://picsum.photos/seed/ev${i + 1}/400/600`} />
                  <div className="absolute inset-0 bg-black/40 group-hover:bg-black/20 transition-colors"></div>
                  <div className="absolute top-4 left-4 bg-[#F5C842] px-3 py-2 text-[#24408d] font-bold text-center leading-tight">
                    <span className="block text-xs uppercase">{ev.mois}</span>
                    <span className="block text-xl">{ev.jour}</span>
                  </div>
                  <div className="absolute bottom-0 left-0 p-6 w-full">
                    <p className="text-[#F5C842] italic font-medium mb-1">{ev.categorie}</p>
                    <h4 className="text-white font-bold text-lg mb-4">{ev.titre}</h4>
                    <div className="flex items-center text-white/90 text-sm"><span className="material-symbols-outlined text-sm mr-2">schedule</span>{ev.horaire}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* ═══ ENGAGEMENT ═══ */}
        <section className="relative py-40 overflow-hidden">
          <div className="absolute inset-0 z-0">
            <img className="w-full h-full object-cover" src="https://lh3.googleusercontent.com/aida-public/AB6AXuCh8iJNGQ15V6gcp5fJavkaTKp0ifr58x8ek9Oi8m_oCpa-mQ18TB66_MBSdk2G954xhrimFX1BKL_OD04JuTkzUOc-EHFmtIuq5eAWH8inqbgS996nItujbFMpIIC8WLz622G1BOwZkx82MBZt41L0hFe2TRK7xlgO27rukL8aZeSrogV77WeLkD9TEZeuttTGV4rbh1cGF03VJV9ZfQTilBWMBtTGzxZbhhLa5eUw70sZ1yFiBS3Jd5tdguKEIgBY6aLWGbttE48" alt="" />
            <div className="absolute inset-0 bg-[#24408d]/80 backdrop-blur-[2px]"></div>
          </div>
          <div className="container mx-auto max-w-7xl px-4 md:px-8 relative z-10 text-center">
            <h2 className="text-white font-headline font-bold text-4xl md:text-6xl mb-12 tracking-tight">{c.engagement.titre}</h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8 max-w-5xl mx-auto">
              {c.engagement.boutons.map((b, i) => (
                <button key={i} className="bg-white text-[#24408d] px-8 py-10 rounded-3xl lg:rounded-full font-headline font-extrabold text-xl lg:text-2xl hover:bg-[#fdd34d] hover:text-[#725b00] transition-all flex flex-col items-center gap-4 group">
                  <span className="material-symbols-outlined text-4xl group-hover:scale-125 transition-transform">{b.icone}</span>
                  {b.label}
                </button>
              ))}
            </div>
          </div>
        </section>
      </main>

      {/* ═══ FOOTER PREMIUM ═══ */}
      <footer className="ff-footer w-full text-white mt-0">
        {/* Bandeau newsletter */}
        <div className="relative z-10 border-b border-white/10">
          <div className="max-w-7xl mx-auto px-6 lg:px-12 py-12 grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
            <div>
              <p className="font-script text-[#F5C842] text-3xl mb-2">{c.footer.newsletter.accroche}</p>
              <h3 className="font-montserrat font-extrabold text-3xl lg:text-4xl uppercase tracking-tight leading-tight">{c.footer.newsletter.titre} <span className="text-[#F5C842]">{c.footer.newsletter.titreAccent}</span></h3>
              <p className="text-white/70 text-sm mt-3 max-w-md">{c.footer.newsletter.description}</p>
            </div>
            <form className="flex flex-col sm:flex-row gap-3 w-full" onSubmit={(e) => e.preventDefault()}>
              <input type="email" placeholder={c.footer.newsletter.placeholder} className="ff-newsletter-input flex-1 px-6 py-4 rounded-full text-white placeholder:text-white/40 text-sm font-medium" />
              <button type="submit" className="bg-[#F5C842] text-[#0D1F6E] px-8 py-4 rounded-full font-montserrat font-extrabold text-sm uppercase tracking-widest whitespace-nowrap hover:bg-white transition-colors">
                <span className="flex items-center gap-2">{c.footer.newsletter.bouton}<span className="material-symbols-outlined text-base">arrow_forward</span></span>
              </button>
            </form>
          </div>
        </div>

        {/* Grille principale */}
        <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-12 py-20 grid grid-cols-2 md:grid-cols-4 lg:grid-cols-12 gap-10">
          {/* Brand */}
          <div className="col-span-2 md:col-span-4 lg:col-span-4">
            <div className="flex items-center gap-3 mb-6">
              <span className="ff-pulse-dot w-3 h-3 rounded-full bg-[#F5C842] inline-block"></span>
              <span className="text-[#F5C842] text-xs font-montserrat font-bold uppercase tracking-[0.3em]">{c.footer.brand.badge}</span>
            </div>
            <h4 className="ff-brand-wordmark font-montserrat font-black text-3xl uppercase tracking-tight leading-none mb-6">{c.footer.brand.nomLigne1}<br />{c.footer.brand.nomLigne2}</h4>
            <p className="text-white/70 text-sm leading-relaxed mb-8 max-w-sm">{c.footer.brand.description}</p>
            <div className="flex items-center gap-3 mb-4">
              {['public', 'photo_camera', 'play_circle', 'group', 'mail'].map((icon, i) => (
                <a key={i} href="#" className="ff-social" aria-label={icon}><span className="material-symbols-outlined text-[#F5C842] text-lg">{icon}</span></a>
              ))}
            </div>
            <span className="inline-block px-3 py-1 bg-white/5 border border-white/10 rounded-full text-[10px] uppercase tracking-widest text-white/60 font-bold">{c.footer.brand.statut}</span>
          </div>

          {/* Navigation */}
          <div className="col-span-1 md:col-span-2 lg:col-span-2">
            <div className="w-8 h-0.5 ff-gold-line mb-5"></div>
            <h5 className="font-montserrat font-extrabold text-sm uppercase tracking-[0.25em] text-white mb-6">{c.footer.navigation.titre}</h5>
            <ul className="space-y-3.5 text-sm">
              {c.footer.navigation.liens.map((l, i) => (
                <li key={i}><Link to={l.href.startsWith('/') ? l.href : '/'} className="ff-link text-white/70 block">{l.label}</Link></li>
              ))}
            </ul>
          </div>

          {/* Programmes */}
          <div className="col-span-1 md:col-span-2 lg:col-span-3">
            <div className="w-8 h-0.5 ff-gold-line mb-5"></div>
            <h5 className="font-montserrat font-extrabold text-sm uppercase tracking-[0.25em] text-white mb-6">{c.footer.programmes.titre}</h5>
            <ul className="space-y-3.5 text-sm">
              {c.footer.programmes.liens.map((p, i) => (
                <li key={i}><a href="#" className="ff-link text-white/70 block">{p}</a></li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div className="col-span-2 md:col-span-4 lg:col-span-3">
            <div className="w-8 h-0.5 ff-gold-line mb-5"></div>
            <h5 className="font-montserrat font-extrabold text-sm uppercase tracking-[0.25em] text-white mb-6">{c.footer.contact.titre}</h5>
            <ul className="space-y-5 text-sm">
              <li className="flex items-start gap-3">
                <span className="material-symbols-outlined text-[#F5C842] text-xl mt-0.5">location_on</span>
                <div className="text-white/70 leading-relaxed">
                  <div className="text-white font-semibold text-xs uppercase tracking-wider mb-1">{c.footer.contact.siegeLabel}</div>
                  {c.footer.contact.siegeAdresse}
                </div>
              </li>
              <li className="flex items-start gap-3">
                <span className="material-symbols-outlined text-[#F5C842] text-xl mt-0.5">apartment</span>
                <div className="text-white/70 leading-relaxed">
                  <div className="text-white font-semibold text-xs uppercase tracking-wider mb-1">{c.footer.contact.chapitreLabel}</div>
                  {c.footer.contact.chapitreAdresse}
                </div>
              </li>
              <li className="flex items-start gap-3">
                <span className="material-symbols-outlined text-[#F5C842] text-xl mt-0.5">mail</span>
                <a href={`mailto:${c.footer.contact.email}`} className="text-white/70 hover:text-[#F5C842] transition-colors leading-relaxed break-all">{c.footer.contact.email}</a>
              </li>
              <li className="flex items-start gap-3">
                <span className="material-symbols-outlined text-[#F5C842] text-xl mt-0.5">call</span>
                <span className="text-white/70">{c.footer.contact.telephone}</span>
              </li>
            </ul>
            <a href="#" className="mt-8 inline-flex items-center gap-2 bg-transparent border-2 border-[#F5C842] px-7 py-3 rounded-full font-montserrat font-extrabold text-xs uppercase tracking-widest text-[#F5C842] hover:bg-[#F5C842] hover:text-[#0D1F6E] transition-all">
              <span className="material-symbols-outlined text-base">favorite</span> {c.footer.contact.boutonDon}
            </a>
          </div>
        </div>

        {/* Modes de paiement */}
        <div className="relative z-10 border-t border-white/10">
          <div className="max-w-7xl mx-auto px-6 lg:px-12 py-8 flex flex-col lg:flex-row items-start lg:items-center gap-6 justify-between">
            <div className="flex items-center gap-3">
              <span className="material-symbols-outlined text-[#F5C842]">payments</span>
              <span className="text-xs uppercase tracking-[0.25em] font-montserrat font-bold text-white/80">{c.footer.paiements.titre}</span>
            </div>
            <div className="flex flex-wrap gap-3">
              {c.footer.paiements.methodes.map((m, i) => (
                <span key={i} className="ff-pay-badge px-4 py-2 bg-white/5 border border-white/10 rounded-full text-xs font-bold text-white/80 tracking-wider">{m}</span>
              ))}
            </div>
          </div>
        </div>

        {/* Barre légale */}
        <div className="relative z-10 border-t border-white/10 bg-black/20">
          <div className="max-w-7xl mx-auto px-6 lg:px-12 py-6 flex flex-col md:flex-row items-center gap-4 justify-between text-xs">
            <p className="text-white/50 font-medium text-center md:text-left">
              {c.footer.legal.copyright} <span className="text-white font-bold">{c.footer.legal.nom}</span> — {c.footer.legal.mention}
            </p>
            <div className="flex items-center gap-6 text-white/50">
              {c.footer.legal.liens.map((l, i) => (
                <span key={i} className="flex items-center gap-6">
                  <a href="#" className="hover:text-[#F5C842] transition-colors">{l}</a>
                  {i < c.footer.legal.liens.length - 1 && <span className="w-1 h-1 rounded-full bg-white/30"></span>}
                </span>
              ))}
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}
